

































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import VModal from "@/components/VModal.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import DialogModal from "@/components/DialogModal.vue";
import VAccordion from "@/components/VAccordion.vue";
import VSlottedSelect, {
  SlottedSelectItem,
  SlottedSelectGroup,
} from "@/components/VSlottedSelect.vue";
import VCard from "@/components/VCard.vue";
import VCardDock from "@/components/VCardDock.vue";
import MediumCard, {
  MediumCardGroup,
} from "@/components/Analysis/MediumCard.vue";
import VResumeeCard, { ResumeeItem } from "@/components/VResumeeCard.vue";
import VSidedPieChart from "@/components/VSidedPieChart.vue";
import CoverageCard from "@/components/Analysis/CoverageCard.vue";
import PopulationCard, {
  PopulationGroup,
} from "@/components/Analysis/PopulationCard.vue";

@Component({
  components: {
    VModal,
    ConfirmModal,
    DialogModal,
    VAccordion,
    VSlottedSelect,
    VCard,
    VCardDock,
    MediumCard,
    VResumeeCard,
    VSidedPieChart,
    CoverageCard,
    PopulationCard,
  },
})
export default class Modals extends Vue {
  selected: SlottedSelectItem = {
    icon: "aree",
    id: "ok",
    text: "aree",
    additional: "magnai",
  };
  selectedGroups: SlottedSelectItem = {
    icon: "aree",
    id: "ok",
    text: "aree",
    additional: "magnai",
  };

  groups: SlottedSelectGroup[] = [
    {
      id: "m",
      name: "Maestre",
      items: [
        {
          icon: "aree",
          id: "ok",
          text: "aree",
          additional: "magnai",
        },
        {
          icon: "iso-bike",
          id: "bike",
          text: "bicicletta",
          additional: "tosto",
        },
      ],
    },
    {
      id: "k",
      name: "Prof",
      items: [
        {
          icon: "iso-bus",
          id: "as",
          text: "Serena",
          additional: "ligia",
        },
        {
          icon: "iso-walk",
          id: "wk",
          text: "Armando",
          additional: "casco",
        },
      ],
    },
  ];
  items: SlottedSelectItem[] = [
    {
      icon: "aree",
      id: "ok",
      text: "aree",
      additional: "magnai",
    },
    {
      icon: "iso-bike",
      id: "bike",
      text: "bicicletta",
      additional: "tosto",
    },
  ];

  cardGroups: MediumCardGroup[] = [
    {
      id: "national",
      name: "Nazionali",
      items: [
        {
          icon: "aree",
          id: "ok",
          text: "aree",
          budget: 10000,
          count: 3,
        },
        {
          icon: "iso-bike",
          id: "bike",
          text: "bicicletta",
          budget: 0,
          count: 0,
        },
      ],
    },
    {
      id: "local",
      name: "Locali",
      items: [
        {
          icon: "iso-bus",
          id: "as",
          text: "Serena",
          budget: 300,
          count: 5,
        },
        {
          icon: "iso-walk",
          id: "wk",
          text: "Armando",
          budget: 0,
          count: 0,
        },
      ],
    },
  ];

  resumeeItems = [
    {
      text: "13",
      description: "Mezzi",
      icon: "media-tv",
    },
    {
      text: "320.000 €",
      description: "Budget",
      icon: "media-radio",
    },
  ];
  pieTitle = "Test";
  pieTotal = 100;
  pieSlice = 25;

  populationGroups: PopulationGroup[] = [
    {
      title: "Popolazione Residente per classe di età",
      items: [
        {
          type: "pair",
          key: "0-15",
          value: 10000,
        },
        {
          type: "pair",
          key: "16-30",
          value: 11000,
        },
      ],
    },
    {
      title: "Popolazione Residente Equivalente",
      items: [
        {
          type: "scalar",
          value: 9853122,
        },
      ],
    },
    {
      title: "Test scalare con test",
      items: [
        {
          type: "scalar",
          value: "Ciao!",
        },
      ],
    },
  ];

  openModal() {
    (this.$refs.modal as VModal).show();
  }

  async openConfirm() {
    await (this.$refs.confirmModal as ConfirmModal).confirm(
      "Dialogo da confermare"
    );
  }

  async openDialog() {
    await (this.$refs.dialogModal as DialogModal).dialog("Messaggio");
  }
}
